import type { ConsultationPayload } from '@/types/patients';

/**
 * One line that says what a visit was about, for a row in a visit list.
 *
 * A visit typed up from the doctor's paper has free text; one from the doctor's
 * own form has picklist entries; a few have both. The free text leads, cut to
 * its first line — it is what a person wrote about this visit, and a list row
 * has room for one line of it. Returns null when the visit records neither, so
 * the caller chooses its own placeholder.
 */
export function visitPreview(payload: ConsultationPayload): string | null {
  const firstLine = payload.diagnosisNote
    ?.split('\n')
    .map((line) => line.trim())
    .find((line) => line !== '');
  const parts = [firstLine, ...(payload.diagnoses ?? [])].filter(
    (part): part is string => !!part,
  );
  return parts.length > 0 ? parts.join(', ') : null;
}
